<script lang="typescript">
    import type { Lens } from "./types";
    import { state } from "./stores.js";
    import { getBasePrice, getBaseLensImage, getBaseLensName } from "./utils";
    import { fly } from "svelte/transition";
    import PriceDisplay from "./PriceDisplay.svelte";
    import LensBenefitImageColumn from "./LensBenefitImageColumn.svelte";
    export let onClick;
    export let selectedLens: Lens;
    export let image: string = "";

    if (!image) {
        image = getBaseLensImage(selectedLens, $state.region);
    }
</script>

<div class="local-container">
    <img src={image} class="w-40 object-contain" alt="spectacle lens" />
    <div class="w-full">
        <div class="ml-8 mr-auto">
            <div class="border-b border-white pb-4 flex justify-between items-end">
                <h1 class="inline">{@html getBaseLensName(selectedLens, $state.region)}</h1>
                <PriceDisplay price={getBasePrice(selectedLens, $state.region)} />
            </div>
        </div>
        <div class="ml-8 mt-8 flex justify-between items-start">
            <ul>
                {#each selectedLens.description as text}
                    <li class="list-outside ml-4">{text}</li>
                {/each}
            </ul>
            <button type="button" class="btn-secondary btn-sm" on:click={onClick}>
                Order<span class="font-bold">&nbsp;&nbsp;&gt;</span>
            </button>
        </div>
        <div class="flex ml-8 mt-8 flex-wrap">
            {#each selectedLens.benefits as benefit, i (getBaseLensImage(selectedLens, $state.region) + benefit.title)}
                <div class="mr-4" in:fly={{ x: 400, duration: 400, delay: i * 100 }}>
                    <LensBenefitImageColumn {benefit} />
                </div>
            {/each}
        </div>
    </div>
</div>

<style>
    .local-container {
        @apply transition-shadow hover:shadow-md flex justify-between;
        @apply w-full lg:w-3/4 bg-primary text-white p-8 items-start mt-8;
        @apply mx-8 lg:mx-auto;
    }

    ul li {
        @apply mb-2 pr-4;
    }
</style>
